import { Panel, Chip, Th, Td } from "@/components/common";
import { Switch } from "@/components/ui/switch";
import { fmt, cur } from "@/lib/api";

function activeTarget(row, price) {
  if (!row || row.status !== "READY" || price == null) return "-";
  return price > row.P ? `Up ${fmt(row.upside_target)}` : `Down ${fmt(row.downside_target)}`;
}

export function LevelsBoard({ board, windows, day, onToggle }) {
  return (
    <Panel title={`Today's levels board, ${day || ""}`} testid="levels-board">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1200px]" data-testid="levels-board-table">
          <thead className="border-b border-slate-800">
            <tr>
              <Th>On</Th><Th>Market</Th><Th>Price</Th><Th className="text-emerald-400">S2</Th><Th className="text-emerald-300">S1</Th><Th className="text-sky-300">P</Th><Th className="text-rose-300">R1</Th><Th className="text-rose-400">R2</Th>
              <Th>Active target</Th><Th>Window</Th><Th>Size</Th><Th>TP</Th><Th>Hold</Th><Th>Reverse</Th><Th>Mode</Th><Th>State</Th><Th>Source</Th>
            </tr>
          </thead>
          <tbody>
            {(board || []).map(({ market: m, row, price, tick_age, feed_error, window: bw, effective_size: es, mt5_lots: lt, backup_price: bk }) => {
              const w = bw || windows?.[m.window] || {};
              const ready = row?.status === "READY";
              const state = !m.enabled ? "SKIPPED" : row?.state || "PENDING";
              return (
                <tr key={m.key} data-testid={`levels-row-${m.key}`} className={`border-b border-slate-800/60 transition-colors hover:bg-slate-800/40 ${m.enabled ? "" : "opacity-50"}`}>
                  <Td><Switch data-testid={`levels-market-toggle-${m.key}`} checked={!!m.enabled} onCheckedChange={(v) => onToggle?.(m, v)} /></Td>
                  <Td><div className="font-medium text-slate-100">{m.name}</div><div className="num text-[11px] text-slate-500">{m.symbol}</div></Td>
                  <Td className="num" data-testid={`levels-price-${m.key}`}>
                    {bk ? (
                      <>
                        <span className="text-slate-300">{fmt(bk.price)}</span>
                        <div data-testid={`levels-backup-price-${m.key}`} className="text-[10px] text-sky-300" title={`Display only from ${bk.symbol}. Trades only use MT5 prices.`}>backup feed{feed_error ? ", MT5 closed" : ""}</div>
                      </>
                    ) : (
                      <>
                        {price != null ? fmt(price) : "-"}
                        {tick_age != null && tick_age > 180 && <div className="text-[10px] text-amber-400">stale {Math.round(tick_age)}s</div>}
                        {feed_error && <div className="text-[10px] text-rose-400">symbol error</div>}
                      </>
                    )}
                  </Td>
                  {["S2", "S1", "P", "R1", "R2"].map((k) => <Td key={k} className="num" data-testid={`levels-${m.key}-${k}`}>{ready ? fmt(row[k]) : "-"}</Td>)}
                  <Td className="num text-indigo-300">{activeTarget(row, price)}</Td>
                  <Td className="num text-xs text-slate-400">{m.window} {w.open}-{w.cutoff}, close {w.close}{m.window_override ? " *" : ""}</Td>
                  <Td className="num" data-testid={`levels-size-${m.key}`}>{cur()}{fmt(es ?? m.size)}{lt && <div className={`text-[10px] ${lt.error ? "text-rose-400" : "text-slate-500"}`} title={lt.error || `${lt.actual_per_point}/pt on MT5`}>{lt.error ? (lt.error.includes("does not allow") ? "broker blocks live" : "no MT5 size") : `${lt.lots} lots`}</div>}</Td>
                  <Td className="num">{m.take_profit_points ?? "target"}</Td>
                  <Td>{m.hold_past_close ? "Yes" : "No"}</Td>
                  <Td>{m.reverse_at_target ? "Yes" : "No"}</Td>
                  <Td><Chip status={m.live_mirror ? "LIVE" : "PAPER"} label={m.live_mirror ? "Live mirror" : "Paper only"} /></Td>
                  <Td><Chip status={state} testid={`levels-state-${m.key}`} />{row?.reason && <div className="mt-0.5 max-w-[180px] truncate text-[10px] text-slate-500" title={row.reason}>{row.reason}</div>}</Td>
                  <Td className="text-[11px] text-slate-400"><div>{row?.source || "waiting for MT5 data"}</div>{ready && <div className="num text-slate-600">H {fmt(row.high)} L {fmt(row.low)} C {fmt(row.close)}</div>}</Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Panel>
  );
}
